import React, { useEffect, useState } from 'react';
import { makeStyles } from '@mui/styles';
import Paper from '@mui/material/Paper';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Button from '@mui/material/Button';
import { confirmAlert } from 'react-confirm-alert';

import { RltFreqFindAluno } from './RltFreqFindAluno';
import TextField from '../../../UI/TextField';
import { Grid } from '@mui/material';
import Select from '../../../UI/Select';
import { findFrequenciaAlunoMesAnoLetivo } from '../../../PresencaAluno/api-presenca-aluno';
import { RltFrequencia } from './RltFrequencia';
import { useNavigate } from 'react-router';

const useStyles = makeStyles({
    paper: {
        padding: '20px',
        backgroundColor: 'white',
    },
    title: {
        textAlign: 'center',
        marginBottom: '20px'

    },
    adicionarDisciplina: {
        paddingBottom: '10px',
    },
    formControl: {
        marginBottom: '10px'
    },
    cursorLink: {
        cursor: 'pointer'
    },
    gerarRelatorio: {
        marginTop: "15px"
    }
});

export default function RltFrequenciaPorAlunoMesAnoLetivo(props) {
    const classes = useStyles();
    const [listAlunos, setListAlunos] = useState([]);
    const [open, setOpen] = useState(false);
    const [aluno, setAluno] = useState(null);
    const [openReport, setOpenReport] = useState(false);
    const [anoLetivo, setAnoLetivo] = useState();
    const listMes = [
        { value: 1, description: "Janeiro" },
        { value: 2, description: "Fevereiro" },
        { value: 3, description: "Março" },
        { value: 4, description: "Abril" },
        { value: 5, description: "Maio" },
        { value: 6, description: "Junho" },
        { value: 7, description: "Julho" },
        { value: 8, description: "Agosto" },
        { value: 9, description: "Setembro" },
        { value: 10, description: "Outubro" },
        { value: 11, description: "Novembro" },
        { value: 12, description: "Dezembro" },
    ];
    const [mes, setMes] = useState(1);
    const [listMesSelect, setListMesSelect] = useState([]);
    const [listFrequencia, setListFrequencia] = useState([]);
    const history = useNavigate();


    useEffect(() => {
        if (aluno !== null) {
            setListAlunos((prevState) => [...prevState, aluno]);
            setAluno(null)
        }
    }, [aluno]);

    useEffect(() => {
        function fetchData() {
            if (openReport) {
                listAlunos.map((aluno) => {
                    listMesSelect.map((mesSelect) => {
                        findFrequenciaAlunoMesAnoLetivo(aluno.codAlunoEscola, mesSelect, anoLetivo).then((data) => {
                            if (data && !data.error) {
                                setListFrequencia((prevState) => [...prevState, data]);
                            }
                        })
                        return null;
                    })
                    return null;

                })

            }
        }
        fetchData();

    }, [openReport, mes, anoLetivo, listAlunos, listMesSelect]);

    const handleDelete = (codAluno) => {
        confirmAlert({
            title: 'Alerta',
            message: 'Deseja deletar este aluno?',
            buttons: [
                {
                    label: 'Sim',
                    onClick: () => {
                        setListAlunos((prevState) => prevState.filter((ps) => ps.codigo !== codAluno));
                    }
                },
                {
                    label: 'Não',
                    onClick: () => { }
                }
            ]
        });

    };

    const onChangeAnoLetivo = (event) => {
        setAnoLetivo(event.target.value);
    }

    const onChangeMes = (event) => {
        setMes(event.target.value);
    }

    const handleSelectMes = () => {
        setListMesSelect((prevState) => ([...prevState, mes]))
    }

    const handleRemoveMesSelect = (mesSelect) => {
        setListMesSelect((prevState) => prevState.filter((ps) => ps !== mesSelect));
    }

    return (
        <Container className={classes.paper} component={Paper}>
            <Button
                onClick={() => history(-1)}
                variant="contained"
                color="secondary"
                className={classes.voltarButton}
            >
                <ArrowBackIcon style={{ marginRight: '10px' }} />
                Voltar
            </Button>
            <Typography className={classes.title} variant="h5">
                Frequência por Aluno, Mês e Ano Letivo
            </Typography>
            {openReport ?
                <RltFrequencia
                    listFrequencia={listFrequencia}
                    setOpenReport={setOpenReport}
                /> : <>
                    <RltFreqFindAluno
                        open={open}
                        setOpen={setOpen}
                        setAluno={setAluno}
                        listAlunos={listAlunos}
                        handleDelete={handleDelete}
                    />

                    <Grid
                        container
                        direction='row'
                        spacing={3}
                    >
                        <Grid
                            size={{
                                xs: 3,
                                sm: 3,
                                md: 3,
                                lg: 3,
                                xl: 3
                            }}>
                            <TextField
                                value={anoLetivo}
                                fullWidth={false}
                                label="Ano Letivo"
                                onChange={onChangeAnoLetivo}
                            />
                        </Grid>

                        <Grid
                            size={{
                                xs: 3,
                                sm: 3,
                                md: 3,
                                lg: 3,
                                xl: 3
                            }}>
                            <Select
                                className={classes.gerarRelatorio}
                                label="Mês"
                                value={mes}
                                list={listMes}
                                onChange={onChangeMes}
                            />
                            <Button
                                onClick={handleSelectMes}
                            >
                                Adicionar Mês
                            </Button>
                            {listMesSelect.map((mesSelect) => (
                                <>
                                    <Typography variant='body1'>{mesSelect}</Typography>
                                    <Button
                                        onClick={() => handleRemoveMesSelect(mesSelect)}
                                    >
                                        Remover
                                    </Button>
                                </>
                            ))}

                        </Grid>

                        <Grid
                            size={{
                                xs: 3,
                                sm: 3,
                                md: 3,
                                lg: 3,
                                xl: 3
                            }}>
                            <Button
                                onClick={() => {
                                    setOpenReport(true);
                                }}
                                variant="contained"
                                className={classes.gerarRelatorio}
                                color="primary"
                            >
                                Gerar Relatório
                            </Button>

                        </Grid>

                    </Grid>



                </>}
        </Container>
    );
}